const FILTER_COOKIE_KEY = 'bentosmb_open_filters';

class BentoSMB {
  constructor(context) {
    this.openedFilters = this.#getCookie(FILTER_COOKIE_KEY) || {};

    this.#init();
  }

  #init() {
    this.#listen();
    this.#toggleFilters();
  }

  #attempt(func, attempts = 0, _max_attempts = 10, _delay = 500) {
    try {
      func();
    } catch (err) {
      console.error(err);

      if (attempts >= _max_attempts) return;
      setTimeout(this.#attempt.bind(this, func, attempts + 1, _max_attempts, _delay), _delay);
    }
  }

  #listen() {
    this.#listenToFilterTriggers();
    this.#listenToOptionTriggers();
  }

  #listenToFilterTriggers() {
    const els = document.querySelectorAll('div[data-filter]');
    els.forEach(el => el.children.trigger.addEventListener('click', this.#handleFilterTriggerClick.bind(this, el.dataset.filter)));
  }
  
  #listenToOptionTriggers() {
    const els = document.querySelectorAll('div.filter-list > div.option > input.option-filter');
    els.forEach(el => el.addEventListener('click', this.#handleFilterOptionClick.bind(this)));
  }

  #handleFilterTriggerClick(filterName, event) {
    const {target} = event;
    const filterListEl = target.parentNode.querySelector('div.filter-list');

    if (filterListEl === null) return;

    const isOpen = filterListEl.classList.contains('d-none') === false;
    this.openedFilters[filterName] = {open: isOpen};

    this.#setCookie(FILTER_COOKIE_KEY, JSON.stringify(this.openedFilters), true);
  }

  #handleFilterOptionClick(event) {
    const {target} = event;

    const id = target.id;
    const filterName = target.parentNode.parentNode.parentNode.dataset.filter;

    if (this.openedFilters[filterName] === undefined) {
      this.openedFilters[filterName] = {open: isOpen, lastOption: id};
    } else {
      this.openedFilters[filterName].lastOption = id;
    }

    this.#setCookie(FILTER_COOKIE_KEY, JSON.stringify(this.openedFilters), true);
  }

  #toggleFilters() {
    for (const [key, state] of Object.entries(this.openedFilters)) {
      this.#toggleFilter(key, state);
    }

    this.#scrollToLastOption();
  }

  #toggleFilter(key, state) {
    if (state.open === true) {
      if (document.querySelector(`div[data-filter="${key}"] div.filter-list.d-none`) === null) {
        this.#scrollToLastOption(key, state.lastOption);
        return;
      }
    } else if (state.open === false) {
      if (document.querySelector(`div[data-filter="${key}"] div.filter-list.d-none`) !== null) {
        return;
      }
    }
    
    const el = document.querySelector(`div[data-filter="${key}"]`)?.children.trigger;

    el.click();

    setTimeout(() => {
      let success = false;
      if (state.open === true) {
        success = document.querySelector(`div[data-filter="${key}"] div.filter-list.d-none`) !== null
      } else if (state.open === false) {
        success = document.querySelector(`div[data-filter="${key}"] div.filter-list.d-none`) === null
      }
      
      if (success === false) {
        this.#toggleFilter(key, state);
      }

      this.#scrollToLastOption(key, state.lastOption);
    }, 100);
  }

  #scrollToLastOption(filterName, id = null) {
    if (id === null) return;
    
    document.getElementById(id).scrollIntoView({
      behavior: 'auto',
      block: 'center',
      inline: 'center'
    }); 

    this.openedFilters[filterName].lastOption = null;
    
    this.#setCookie(FILTER_COOKIE_KEY, JSON.stringify(this.openedFilters), true);
  }
  
  #getCookie(name) {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(cookieName) == 0) {
        let value = cookie.substring(cookieName.length, cookie.length);
        try {
          value = JSON.parse(value);
        } catch {}
        
        return value;
      }
    }

    return null;
  }

  #setCookie(name, value, _session = false) {
    let expires;
    if (_session === false) {
      const date = new Date();
      date.setTime(date.getTime() + 2592000000); // 30 Days
      expires = `expires=${date.toUTCString()};`;
    }

    document.cookie = `${name}=${value};${expires}path=/`;
  }

  #deleteCookie(name) {
      document.cookie = `${name}=;max-age=-99999999;path=/`;
  }
}

window.addEventListener('load', () => {
  typeof BentoSMB !== 'undefined' && new BentoSMB();
});